import { render } from "./home.vue?vue&type=template&id=1c9dbfb6&scoped=true&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=1c9dbfb6&scoped=true&lang=css"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9dbfb6"]])

export default __exports__